<template>
  <div
    class="mt-4 flex w-full flex-row flex-wrap justify-center font-lato font-light uppercase"
  >
    <p class="text-center text-[10px]">
      For details on how your data is used and stored, see our &nbsp;
      <NuxtLink
        to="/privacy"
        external
        target="_blank"
        class="p-0 text-p-900"
        no-prefetch
      >
        Privacy Policy
      </NuxtLink>
    </p>
  </div>
</template>
